import PromoTable from "components/Admin/Tables/PromoTable";
import React, { memo } from "react";
import Widget from "../Widget";

interface Props {}

const PromoWidget: React.FC<Props> = () => {
  return (
    <Widget title="Промоции">
      <PromoTable />
    </Widget>
  );
};

export default memo(PromoWidget);
